import { useRef } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { formatViews } from "@/lib/utils";

export default function FeaturedArticles() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="bg-foreground-950 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
          <div className="flex items-center gap-3">
            <span className="px-3 py-1.5 border border-background-400 text-background-300 text-xs uppercase tracking-wide rounded-full">
              热点追踪
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 md:text-right md:max-w-md">
            正在发酵的
            <br />
            重磅大瓜
          </h2>
        </div>

        <div className="relative">
          <div
            ref={scrollRef}
            className="flex gap-4 md:gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {hotArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group shrink-0 w-72 md:w-80 snap-start"
              >
                <div className="bg-background-50 rounded-lg overflow-hidden">
                  <div className="relative aspect-square overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    {article.isVideo && (
                      <div className="absolute inset-0 flex items-center justify-center bg-foreground-900/30">
                        <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center">
                          <i className="ri-play-fill text-white text-lg" />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-2">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span className="text-primary-600 font-medium">
                        {article.category}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {formatViews(article.views)}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2 mt-6">
            <button
              onClick={() => scroll("left")}
              className="w-10 h-10 border border-background-700 flex items-center justify-center text-background-300 hover:bg-background-800 transition-colors"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <button
              onClick={() => scroll("right")}
              className="w-10 h-10 bg-background-800 flex items-center justify-center text-background-100 hover:bg-background-700 transition-colors"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}